export const FLOWER = 1
export const SHAKE_TRIM = 2
export const IMMATURE_PLANT = 3
export const MATURE_PLANT = 4
export const EDIBLE = 5
export const TINCTURE = 6
export const TOPICAL = 7
export const TRANSDERMALPATCH = 8
export const EXTRACT = 9
export const CONCENTRATE = 10
export const CAPSULE = 11
export const PREROLLS = 12
export const COMBINEDCATEGORY = 13
export const SUPPOSITORY = 14
export const WASTE = 15
export const ANCILLARY = 16
export const OTHER = 17